import React, {useEffect,useState,useContext} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useNavigate } from 'react-router-dom';
import { PiCaretDoubleLeft,PiCaretLeft,PiCaretDoubleRight,PiCaretRight,PiFunnel, PiArrowsLeftRightLight, PiMoneyLight, PiCurrencyDollarLight, PiDeviceMobileLight, PiCalendarLight, PiCheckCircleLight} from "react-icons/pi";
import client from '../client';
import LoadingIcons from "react-loading-icons";
import {Scrollable,Header,Detail,Section,createDialog
} from 'coaz-ui';
import TransactionFilter from './TransactionFilter';
import { formatDate } from '../constants';


const MyTransactions = () => {
    const {version,setVersion} = useContext(GlobalContext);
    const [transactions,setTransactions] = useState([]);
    const [filter,setFilter] = useState({
        userRef:"",
        paymentType:"",
        currency:"",
        amount:"",
        accountNumber:"",
        transactionId:"",
        externalId:"",
        from:"",
        to:"",
        status:""
    });
    const [userRef,setUserRef] = useState("");
    const [account,setAccount] = useState(null);
    const [balance,setBalance] = useState(0);
    const [buttons,setButtons] = useState([]);
    const [pageNo,setPageNo] = useState(0);
    const [pageSize,setPageSize] = useState(0);
    const [totalElements,setTotalElements] = useState(0);
    const [totalPages,setTotalPages] = useState(0);
    const [last,setLast] = useState(true);
    const {request,getCurrent,errorMessage} = client;
    const [page,setPage] = useState({
        pageNo:0,
        pageSize:10,
        sortBy:'id',
        sortDir:'asc'
    })
    const [loading,setLoading] = useState(false);
    const path = useLocation().pathname;
    const navigate = useNavigate();

    let USDecimal = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const onFilter = (e) => {
        createDialog({
            title:"Transaction Filter",
            params:{filter:filter,setFilter:setFilter},
            Component:TransactionFilter,
            version:version,
            setVersion:setVersion
        })
    }

    const handleFirst = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo > 0) {
            setPage({...page, pageNo: 0});
        }
    }

    const handlePrevious = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo > 0) {
            setPage({...page, pageNo: page.pageNo - 1});
        }
    }

    const handleNext = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo < totalPages - 1) {
            setPage({...page, pageNo: page.pageNo + 1});
        }
    }

    const handleLast = (e) => {
        if(e) e.preventDefault();
        
        if(page.pageNo < totalPages - 1 && !last) {
            setPage({...page, pageNo: totalPages - 1});
        }
    }

    const getTransactions = async () => {
        let current = await getCurrent();

        if (!current && !current.user) {
            setTransactions([])
            return;
        }
        let usrRef = ""
        if (path.includes('_mytransactions')) {
            usrRef = current.user.ref.value;
            setUserRef(usrRef);
        } else {
            setUserRef('');
        }
        
        let readAuth = current.authorities.find((auth) => {return auth.authority === 'TRANSACTION:READ'});

        if(!usrRef && !readAuth) {
            setTransactions([])
            return;
        }
        
        await request('GET','transactions/filter-page',null,{
            userRef:usrRef,
            paymentType:filter && filter.paymentType,
            currency:filter && filter.currency,
            amount:filter && filter.amount,
            accountNumber:filter && filter.accountNumber,
            transactionId:filter && filter.transactionId,
            externalId:filter && filter.externalId,
            from:filter && filter.from,
            to:filter && filter.to,
            status:filter && filter.status,
            pageNo:page && page.pageNo,
            pageSize:page && page.pageSize
        })
        .then((response) => {
            if(response && response.content) {
                setTransactions(response.content);
                setPageNo(response.pageNo);
                setPageSize(response.pageSize);
                setTotalElements(response.totalElements);
                setTotalPages(response.totalPages);
                setLast(response.last);
            } else {
                setTransactions(null);
            }
        })
        .catch((error) => {
            setTransactions(null);
        });
    }

    const load = async () => {
        setLoading(true);
        await getTransactions();
        setButtons([
            {
                Icon:PiFunnel,
                name:'Filter',
                handler:onFilter
            }
        ]);
        setLoading(false);
    }

    useEffect(() => {
        load();
    },[path,version])
  return (
    <div className="flex flex-col w-full h-full space-y-4 overflow-hidden">
        <Header Icon={PiArrowsLeftRightLight} text={userRef && userRef !== ""?"My Transactions":"Transactions"} buttons={buttons} />
        {loading ? (
            <div className="flex items-center justify-center w-full h-full">
                <LoadingIcons.SpinningCircles
                    width={64}
                    height={64}
                    fill="rgb(1,175,240)"
                />
            </div>
        ) : (
            <Scrollable vertical={true}>
                <div className="flex flex-col w-full space-y-4">
                    <Section name="Filter">
                        <Detail
                            Icon={PiMoneyLight}
                            label="Payment Type"
                            value={filter && filter.paymentType?filter.paymentType:""}
                        />
                        <Detail
                            Icon={PiCurrencyDollarLight}
                            label="Currency"
                            value={filter && filter.currency?filter.currency:""}
                        />
                        <Detail
                            Icon={PiMoneyLight}
                            label="Amount"
                            value={filter && filter.amount?filter.amount:""}
                        />
                        <Detail
                            Icon={PiDeviceMobileLight}
                            label="Account Number"
                            value={filter && filter.accountNumber?filter.accountNumber:""}
                        />
                        <Detail
                            Icon={PiArrowsLeftRightLight}
                            label="Identifier"
                            value={filter && filter.identifier?filter.identifier:""}
                        />
                        <Detail
                            Icon={PiArrowsLeftRightLight}
                            label="Reference Id"
                            value={filter && filter.referenceId?filter.referenceId:""}
                        />
                        <Detail
                            Icon={PiCalendarLight}
                            label="From"
                            value={filter && filter.from?formatDate(filter.from):""}
                        />
                        <Detail
                            Icon={PiCalendarLight}
                            label="To"
                            value={filter && filter.to?formatDate(filter.to):""}
                        />
                        <Detail
                            Icon={PiCheckCircleLight}
                            label="Status"
                            value={filter && filter.status?filter.status:""}
                        />
                    </Section>
                    <Section name="Transactions" grid={false}>
                        {transactions && transactions.length > 0 && 
                            <div className='flex flex-col w-full h-auto space-y-2 overflow-auto'>
                                {totalElements >  pageSize &&
                                    <div className='flex flex-wrap items-center justify-between w-full h-fit'>
                                        <p className='text-xs font-helveticaNeueRegular text-[rgb(145,145,145)] tracking-wider'>
                                            {`Showing ${transactions && transactions.length > 0?(pageNo * pageSize)+1:0} to ${((pageNo * pageSize)+transactions.length)} of ${totalElements}`}
                                        </p>
                                        <div className='flex flex-row w-fit h-fit space-x-2 text-[rgb(68,71,70)]'> 
                                            <button 
                                                disabled={!pageNo || pageNo < 1}
                                                onClick={handleFirst}
                                                className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                                            >
                                                <PiCaretDoubleLeft size={16} className='flex m-auto'/>
                                            </button>
                                            <button 
                                                disabled={!pageNo || pageNo < 1}
                                                onClick={handlePrevious}
                                                className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                                            >
                                                <PiCaretLeft size={16} className='flex m-auto'/>
                                            </button>
                                            <button 
                                                disabled={last}
                                                onClick={handleNext}
                                                className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                                            >
                                                <PiCaretRight size={16} className='flex m-auto'/>
                                            </button>
                                            <button 
                                                disabled={last}
                                                onClick={handleLast}
                                                className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                                            >
                                                <PiCaretDoubleRight size={16} className='flex m-auto'/>
                                            </button>
                                        </div>
                                    </div>
                                }
                                <div className="relative flex flex-col space-y-2 w-full min-w-[720px]">
                                    <div className="flex flex-row w-full text-xs capitalize text-textFent">
                                        <p className="w-[16.6666%] px-2">Date</p>
                                        <p className="w-[16.6666%] px-2">
                                            Identifier
                                        </p>
                                        <p className="w-[16.6666%] px-2">
                                            Reference Id
                                        </p>
                                        <p className="w-[16.6666%] px-2">
                                            Account Number
                                        </p>
                                        <p className="w-[16.6666%] px-2">
                                            Amount
                                        </p>
                                        <p className="w-[16.6666%] px-2">
                                            Status
                                        </p>
                                    </div>
                                    {transactions && transactions.map((transaction, i) => 
                                        <div key={i} className="flex flex-row w-full">
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {formatDate(transaction.createdDate)}
                                                </p>
                                            </div>
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {transaction.identifier}
                                                </p>
                                            </div>
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {transaction.referenceId}
                                                </p>
                                            </div>
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {transaction.accountNumber}
                                                </p>
                                            </div>
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {`K ${USDecimal.format(transaction.amount)}`}
                                                </p>
                                            </div>
                                            <div className="w-[16.6666%] px-2">
                                                <p className="w-full overflow-hidden text-xs break-words text-text">
                                                    {transaction.status}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </Section>
                </div>
            </Scrollable>
        )}
    </div>
  )
}

export default MyTransactions

